export default (data: string) => {
  let {oneByte, info, contentType, header, body} = ''
  let {fileType, fileName} = ''
  let lastLine = ''
  let bufferText = ''
  let state = 0
  let bufferLength = []
  for (let i = 0; i < data.length; i++) {
    oneByte = data[i]
    const newLineDetected = ((data.charCodeAt(i) === 10) && (data.charCodeAt(i - 1) === 13))
    let newLineChar = ((data.charCodeAt(i) === 10) || (data.charCodeAt(i) === 13))
    if (!newLineChar) {
      lastLine += oneByte
    }
    if ((state === 0) && newLineDetected) {
      state = 1
    }
    if ((state === 1) && newLineDetected) {
      header = lastLine
      lastLine = ''
      state = 2
    } else if ((state === 2) && newLineDetected) {
      contentType = lastLine
      lastLine = ''
      state = 3
      fileType = contentType.split(' ')[1]
    } else if ((state === 3) && newLineDetected) {
      info = lastLine
      lastLine = ''
      state = 4
      fileName = info.split('"')[1]
    } else if (state === 4) {
      if ((header + '--') === lastLine) {
        let j = bufferLength.length - lastLine.length
        let part = bufferText.slice(0, j - 1)
        body = part.trim()
        state = 5
      } else {
        bufferText += oneByte
      }
      if (newLineDetected) lastLine = ''
    } else if (state === 5) {
      if (newLineDetected) state = 1
    }
  }
  let allParts = {header, info, contentType, body, fileName, fileType}
  return allParts
}



// WEBPACK FOOTER //
// ./src/multipart-parser.js